module.exports = __webpack_public_path__ + "img/heart2.a3578d06.png";